export function normalizeRoutes(routes, parentPath = "", parentPermissions = []) {
  return routes.flatMap((route) => {
    const fullPath = route.index
      ? parentPath
      : `${parentPath}${route.path?.startsWith("/") ? "" : "/"}${route.path || ""}`;

    const permissions = route.Permissions?.length
      ? route.Permissions
      : parentPermissions;

    const normalized = { ...route, path: fullPath, Permissions: permissions };

    const children = route.children
      ? normalizeRoutes(route.children, fullPath, permissions)
      : [];

    return [normalized, ...children];
  });
}
